import React, { Component, useState, useEffect, bootstrap } from 'react';
import { connect } from 'react-redux'
import { addToCart, addToOrders } from './reducers/cartReducer'
import { removeItem } from './reducers/cartReducer'
import { fetchData } from './reducers/cartReducer'
import Navbar from './Navbar'
import Modal from 'react-bootstrap/Modal'
import M from 'materialize-css'
import Button from 'react-bootstrap/Modal'
import Item1 from '../images/WRAPS.jpg'
import Item2 from '../images/item2.jpg'
import Item3 from '../images/item_163.jpg'
import Item4 from '../images/item4.jpg'
import Item6 from '../images/item6.jpg'
import Item5 from '../images/item25.jpg'
import { Link } from 'react-router-dom'
import swal from 'sweetalert';
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { Container, Row, Col } from 'reactstrap';


const Toppings = (props) => {
    let choiceType = []



    if (props.invItems !== "null") {
        return (
            <div className="clear">Add toppings


                <select id={"topping_select" + props.baseid} >

                    {props.items.map((t) => (t.category === "Topping") &&
                        props.invItems.indexOf(t.id) > -1
                        ? <option className="waves-effect waves-light btn pink add" value={t.id}>{t.title}
                            {props.topselected.length > 1 ? " add$0.50" : " "}</option> : "")}
                </select>

                <button className="waves-effect waves-light btn pink add" onClick={() => { props.handleClick(document.getElementById("topping_select" + props.baseid).value, props.baseid) }}>Add</button>
                <button className="waves-effect waves-light btn pink add" onClick={() => { props.handleRemoveClick("0", props.baseid) }}>Clear </button>
            </div>)
    }
    if (props.choices !== "null") {


        for (const [key, value] of Object.entries(JSON.parse(props.choices))) {
            choiceType.push(key)

        }
        return (
            <div>

                {choiceType.map((choice) => <div>

                    <div class="tophead card-panel blue lighten-2" onClick={() => { props.handleShow(choice) }}><label><input type="checkbox"

                        checked={props.showSelected == choice || props.topselected.filter((top) => top.subCategory == choice).length >= 1 ? true : false} /><span style={{ color: "Black" }}><b>{choice}</b> </span></label>
                        {props.topselected.map((top) => top.subCategory == choice ? " - " + top.title : "")}</div>

                    {props.items.map((t) => (t.category === "Choice") && t.subCategory == choice &&
                        props.choices.indexOf(t.id) > -1 && props.showSelected == choice
                        ? <label><input type="radio" name={t.subCategory} checked={props.topselected.filter((top) => top.id == t.id).length == 1 ? true : false} onClick={() => { props.handleClick(t.id, props.baseid, t.category, t.subCategory) }} value={t.id} /> <span style={{ color: "Black" }}>{t.title} </span><br />
                        </label> : "")}


                </div>)}


            </div>
        )
    }
    else {
        return (
            <div></div>
        )

    }


}

const ExtraItems = (props) => {
    let addItemType = []
    let dressToppings = []
    dressToppings = props.topselected.filter(top => top.subCategory == "Dressings")
    if (props.addItems !== "null") {

        for (const [key, value] of Object.entries(JSON.parse(props.addItems))) {
            addItemType.push(key)

        }
        return (
            < div>
                {addItemType.map((choice) => <div>
                    <div class="tophead card-panel blue lighten-2" onClick={() => { props.handleShow(choice) }}><label><input type="checkbox"
                        checked={props.showSelected == choice || props.topselected.filter((top) => top.subCategory == choice).length >= 1 ? true : false} /><span style={{ color: "Black" }}><b>{choice}</b> </span></label>
                        {props.topselected.map((top) => top.subCategory == choice ? " - " + top.title : "")}</div>
                    {props.items.map((t) => t.subCategory == choice &&
                        props.addItems.indexOf(t.id) > -1 && props.showSelected == choice
                        ? <label><input type="checkbox" name={t.title} checked={props.topselected.filter((top) => top.id == t.id).length == 1 ? true : false} onClick={() => { props.handleClick(t.id, props.baseid, t.category, t.subCategory) }} value={t.id} />
                            <span style={{ color: "Black" }}>{t.title} {/* {dressToppings.length>2 && dressToppings.filter((k)=>k.title ===t.title).length===0   ? "- add $0.25":""} */} </span><br />
                        </label> : "")}


                </div>)}
            </div>
        )
    }
    else { return (<div></div>) }

}


const Condiments = (props) => {

    let addItemType = []
    let condToppings = []
    let dressToppings = []
    let dippingToppings = []
    condToppings = props.topselected.filter(top => top.subCategory == "Sauces")
    dressToppings = props.topselected.filter(top => top.subCategory == "Dressings")
    dippingToppings = props.topselected.filter(top => top.subCategory == "Dipping Sauce")

    if (props.condiments !== "null") {

        for (const [key, value] of Object.entries(JSON.parse(props.condiments))) {
            addItemType.push(key)

        }
        return (
            < div>
                {addItemType.map((choice) => <div>
                    {choice != "Dressings" ? <div class="tophead card-panel blue lighten-2" onClick={() => { props.handleShow(choice) }}><label><input type="checkbox"
                        checked={props.showSelected == choice || props.topselected.filter((top) => top.subCategory == choice).length >= 1 ? true : false} /><span style={{ color: "Black" }}><b>{choice}</b> </span></label>
                        {props.topselected.map((top) => top.subCategory == choice ? " - " + top.title : "")} </div> : ""}
                    {props.items.map((t) => (t.category === "Condiments") && t.subCategory != "Dressings" && t.subCategory == choice &&
                        props.condiments.indexOf(t.id) > -1 && props.showSelected == choice
                        ? <label><input type="checkbox" name={t.title} checked={props.topselected.filter((top) => top.id == t.id).length == 1 ? true : false} onClick={() => { props.handleClick(t.id, props.baseid, t.category, t.subCategory) }} value={t.id} />
                            <span style={{ color: "Black" }}>{t.title}  {/*{condToppings.length>2 && condToppings.filter((k)=>k.title ===t.title).length===0   ? "- add $0.25":""} */} </span><br />
                            {/* <span style={{color:"Black"}}> {dippingToppings.length>2 && dippingToppings.filter((k)=>k.title ===t.title).length===0   ? "- add $0.25":""}  </span> */}
                        </label> : "")}



                </div>)}

                {addItemType.map((choice) => (choice == "Dressings") && props.baseTitle == "House Salad" ? <div>
                    {props.baseTitle == "House Salad" ? <div class="tophead card-panel blue lighten-2" onClick={() => { props.handleShow(choice) }}><label><input type="checkbox"
                        checked={props.showSelected == choice || props.topselected.filter((top) => top.subCategory == choice).length >= 1 ? true : false} /><span style={{ color: "Black" }}><b>{choice}</b> </span></label>
                        {props.topselected.map((top) => top.subCategory == choice ? " - " + top.title : "")} </div> : ""}
                    {props.items.map((t) => (t.category === "Condiments") && t.subCategory == "Dressings" &&
                        props.condiments.indexOf(t.id) > -1 && props.showSelected == choice
                        ? <label><input type="checkbox" name={t.title} checked={props.topselected.filter((top) => top.id == t.id).length == 1 ? true : false} onClick={() => { props.handleClick(t.id, props.baseid, t.category, t.subCategory) }} value={t.id} />
                            <span style={{ color: "Black" }}>{t.title} {/* {dressToppings.length>2 && dressToppings.filter((k)=>k.title ===t.title).length===0   ? "- add $0.25":""}*/}  </span><br />
                        </label> : "")}



                </div> : "")}

            </div>
        )
    }
    else { return (<div></div>) }

}

const Sides = (props) => {
    let sideType = []
    let condToppings = []
    if (props.sides !== "null") {

        condToppings = props.topselected.filter(top => top.subCategory == "Dressings")


        for (const [key, value] of Object.entries(JSON.parse(props.sides))) {
            sideType.push(key)

        }
        return (
            < div>
                {sideType.map((choice) => <div>
                    <div class="tophead card-panel blue lighten-2" onClick={() => { props.handleShow(choice) }}><label><input type="checkbox"
                        checked={props.showSelected == choice || props.topselected.filter((top) => top.subCategory == choice).length >= 1 ? true : false} /><span style={{ color: "Black" }}><b>{choice}</b> </span></label>
                        {props.topselected.map((top) => top.subCategory == choice ? " - " + top.title : "")}</div>
                    {props.items.map((t) => t.subCategory == choice &&
                        props.sides.indexOf(t.id) > -1 && props.showSelected == choice
                        ? <label><input type="radio" name={t.title} checked={props.topselected.filter((top) => top.id == t.id).length == 1 ? true : false} onClick={() => { props.handleClick(t.id, props.baseid, t.category, t.subCategory) }} value={t.id} /> <span style={{ color: "Black" }}>{t.title} </span><br />
                        </label> : "")}


                </div>)}
                {props.topselected.map((top) => top.title == "House Salad" && (props.showSelected == "Side" || props.showSelected == "Garnish Salad") ? <div>
                    <div class="tophead card-panel blue lighten-2"> <b>Dressings - </b>
                        {props.topselected.map((top) => top.subCategory == "Dressings" ? " - " + top.title : "")}</div>
                    {props.items.map((t) => (t.category === "Condiments") && t.subCategory == "Dressings" && (props.showSelected == "Side" || props.showSelected == "Garnish Salad") &&
                        props.condiments.indexOf(t.id) > -1
                        ? <label><input type="checkbox" name={t.subCategory} checked={props.topselected.filter((top) => top.id == t.id).length >= 1 ? true : false} onClick={() => { props.handleClick(t.id, props.baseid, t.category, t.subCategory) }} value={t.id} />
                            <span style={{ color: "Black" }}>{t.title}             {/* {condToppings.length>2 && condToppings.filter((k)=>k.title ===t.title).length===0   ? "- add $0.25":""}*/}  </span><br />

                        </label> : "")}
                </div> : "")}
            </div>
        )
    }
    else { return (<div></div>) }

}

const Beverages = (props) => (
    <div className="clear">Select beverage type:
        <select id={"topping_select" + props.baseid} >
            {props.items.map((t) => (t.category === "Beverage") ? <option className="waves-effect waves-light btn pink add"
                value={t.id}>{t.title} </option> : "")}
        </select>
        {props.qty > props.topselected.length ? <button className="waves-effect waves-light btn pink add" onClick={() => { props.handleClick(document.getElementById("topping_select" + props.baseid).value, props.baseid) }}>Add</button> : ""}
        {props.qty === props.topselected.length ? <button className="waves-effect waves-light btn pink add" onClick={() => { props.handleChangeClick(document.getElementById("topping_select" + props.baseid).value, props.baseid) }}>Change</button> : ""}

        <button className="waves-effect waves-light btn pink add" onClick={() => { props.handleRemoveClick(0, props.baseid) }}>Clear </button>
    </div>
);


class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            itemSelected: "",
            showSelected: ""
        }
    }

    componentDidMount() {

        if (this.props.items.length == 0) {
            this.props.fetchData();
        }

    }



    handleRemoveClick = (id, baseid) => {
        this.props.removeItem(id + "_" + baseid);

        this.props.items.find(item => item.id === baseid).quantity = 0
        this.props.items.find(item => item.id === baseid).topping = []
        this.forceUpdate(); //relad the component
    }

    handleChangeClick = (id, baseid) => {
        if (id !== baseid)//topping
        {
            //remove the last  beverage
            this.props.items.find(item => item.id === baseid).topping = [];
            this.props.addToCart(id + "_" + baseid);
        }

        this.setState({ total: 1 })
        this.forceUpdate();
    }


    handleShowHide = (value) => {
        this.setState({ showSelected: value })
    }

    handleClick = (id, baseid, category, subcategory) => {


        if (id !== baseid)//topping
        {
            var pizzaselected = false;
            var selected = false;
            pizzaselected = this.props.items.find(t => t.id === baseid).quantity > 0;
            if (!pizzaselected) {
                swal("Add the main item first");
                return;
            }

            this.props.addToCart(id + "_" + baseid + ":" + category + "*" + subcategory);

        }
        else //base item
        { 
            if(subcategory == "remove"){
                this.props.addToCart(id+"_"+baseid+":"+subcategory+"*");  
               
                let changedIteme= this.props.items.find(x=>x.id == baseid) 
              
                if(changedIteme.quantity<1){
                    this.setState({ itemSelected: "" })
                }
                //
               
              }else{
            this.props.addToCart(id + "_" + baseid); 
        if (category == "Base") {
            this.setState({ itemSelected: id })
        }}
        }
        this.forceUpdate();

    }


    handleAddToOrder = (item) => {
        this.props.addToOrders(item);
        //this.props.addToOrders(item.baseid+"_"+item.title+"_"+item.quantity+"_"+item.topping+"_"+item.price);
        this.handleRemoveClick(item.id, item.id)
        this.setState({ itemSelected: "" })
        this.forceUpdate();
        this.props.history.push("/cart")
    }



    render() {



        let itemList = this.props.items.map(item => {
            //item.mainCategory == this.props.mainCategory &&

            if (item.category === "Base" && item.mainCategory == this.props.mainCategory) {
                if (item.topping === "[]") {
                    item.topping = [];
                }

                if (this.state.itemSelected == "") {

                    return (

                        <div className="card" key={item.id}>

                            <div className="card-image">
                                {item.img != null ? <img src={item.img} onError={(e) => { e.target.onerror = null; e.target.src = "" }} /> : ""}
                                {/* <img src={Item3} alt={item.title}/>                               */}
                                <span to="/" className="btn-floating halfway-fab waves-effect waves red addButton" onClick={()=>{this.handleClick(item.id,item.baseid,item.category)}}><i className="material-icons">add</i></span>
                            {item.quantity > 0 ?
                       <span  className="btn-floating  waves-effect waves red removeButton" onClick={()=>{this.handleClick(item.id,item.baseid,item.category,"remove")}}><i className="material-icons">remove</i></span> :""
                                              } 
 </div>

                            <div className="card-content descBox1">
                                <span className="card-title">{item.title} -  {item.quantity > 0 ? item.quantity : ""}</span>
                                <p>{item.description}</p>
                                <p><b>${item.price}</b></p>


                            </div>
                        </div>
                    )
                }
                else {
                    if (this.state.itemSelected == item.id) {
                        return (

                            <div className="card" key={item.id}>

                                <div className="card-image">
                                    {item.img != null ? <img src={item.img} onError={(e) => { e.target.onerror = null; e.target.src = "" }} /> : ""}

                                    {/* <img src={Item3} alt={item.title}/>                         */}
                                    <span to="/" className="btn-floating halfway-fab waves-effect waves red addButton"  onClick={()=>{this.handleClick(item.id,item.baseid,item.category)}}><i className="material-icons">add</i></span>
                           {item.quantity > 0 ?
                       <span  className="btn-floating halfway  waves-effect waves red removeButton" style={{top:"20px;"}} onClick={()=>{this.handleClick(item.id,item.baseid,item.category,"remove")}}><i className="material-icons">remove</i></span> :""
                                              }    
                        </div>

                                <div className="card-content descBox">
                                    <span className="card-title">{item.title} - {item.quantity > 0 ? item.quantity : ""}</span>
                                    <p>{item.description}</p>
                                    <p><b>Price: ${item.price}</b></p>

                                    {item.quantity > 0 && item.title !== "Beverage" ? <div > <Toppings baseid={item.id} topselected={item.topping} invItems={item.inv_toppingID} choices={item.inv_choices}
                                        items={this.props.items} handleShow={this.handleShowHide} showSelected={this.state.showSelected} handleRemoveClick={this.handleRemoveClick} handleClick={this.handleClick} handleAddToOrder={this.handleAddToOrder} />
                                        <Condiments baseTitle={item.title} baseid={item.id} topselected={item.topping} condiments={item.inv_condiments} items={this.props.items} handleShow={this.handleShowHide}
                                            showSelected={this.state.showSelected} handleRemoveClick={this.handleRemoveClick} handleClick={this.handleClick} handleAddToOrder={this.handleAddToOrder} />
                                        <ExtraItems baseid={item.id} topselected={item.topping} addItems={item.inv_addItems} items={this.props.items} handleShow={this.handleShowHide} z
                                            showSelected={this.state.showSelected} handleRemoveClick={this.handleRemoveClick} handleClick={this.handleClick} handleAddToOrder={this.handleAddToOrder} />
                                        <Sides baseid={item.id} topselected={item.topping} condiments={item.inv_condiments} sides={item.inv_sides} items={this.props.items}
                                            handleShow={this.handleShowHide} showSelected={this.state.showSelected} handleRemoveClick={this.handleRemoveClick} handleClick={this.handleClick} handleAddToOrder={this.handleAddToOrder} />

                                    </div> : ""}

                                    {item.quantity > 0 && item.title === "Beverage" ? <Beverages qty={item.quantity} invItems={this.state.details} baseid={item.id} topselected={item.topping}
                                        items={this.props.items} handleRemoveClick={this.handleRemoveClick} handleChangeClick={this.handleChangeClick} handleClick={this.handleClick} handleAddToOrder={this.handleAddToOrder} /> : ""}

                                    {(item.topping.length > 0 && item.quantity > 0) || (item.quantity > 0 && item.inv_toppingID == "null" && item.inv_choices == "null"
                                        && item.inv_condiments == "null" && item.inv_sides == "null") ? <button className='waves-effect waves-light btn green add' onClick={() => { this.handleAddToOrder(item) }}>Add to Cart</button> : ""}


                                </div>
                            </div>
                        )
                    }
                }
            }
        })

        return (
            <div>
                <Navbar isAuthed={true} />
                <div className="container"><br />
                    {/* <div className="example1">
                <h4>This service is only available from 6:30PM to 11:00PM</h4>
            </div> */}

                    {this.state.itemSelected == "" && this.props.mainCategory ? <h5 className="center">SELECT {this.props.mainCategory}</h5> : <br />}
                    <Link name="mainMenu" class="btn mainMenu " to={{
                        pathname: '/',
                        state: {
                            flag: true
                        }
                    }}><b> {"<"} Main Menu</b> </Link>
                    {this.props.orders.length > 0 ?
                        <Link className="waves-effect waves-light btn float-right " style={{ float: "right" }} to="/cart">View cart </Link> : ""}<br />
                    <div className="submenu box">

                        {itemList}
                    </div>

                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {

        items: state.items,
        orders: state.orders,
        mainCategory: state.mainCategory
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => { dispatch(fetchData()) },
        addToOrders: (orderData) => { dispatch(addToOrders(orderData)) },
        addToCart: (id) => { dispatch(addToCart(id)) },
        removeItem: (id) => { dispatch(removeItem(id)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)